/**
 * @file
 * Theme js.
 */
(function ($, Drupal, drupalSettings) {

    'use strict';

    var submenu_functions = false;

  // MIS FUNCIONES:::::::::::::::
    /**
     * Funcion Multilevel del menu
     */
  //---------1
    function menuMultilevel() {

      document.addEventListener("DOMContentLoaded", function(){
        // Hace que los padres no se cierren al pinchar en el hijo (Solo en movil)
        document.querySelectorAll('#navbarNavDropdown .dropdown-menu').forEach(function(element){
          element.addEventListener('click', function (e) {
            e.stopPropagation();
          });
        })

        // Hace que los padres de los submenus no enlacen sino que desplieguen sus hijos (Solo en movil)
        document.querySelectorAll('#navbarNavDropdown .submenu>li>a.dropdown-toggle').forEach(function(element){
          element.addEventListener('click', function (e) {
            e.preventDefault();
          });
        })

        // Despliega y cierra los elementos de submenu de nivel 3 o mayor (Solo en movil)
        document.querySelectorAll('#navbarNavDropdown .dropdown-menu a').forEach(function(element){
          element.addEventListener('click', function (e) {

              let nextEl = this.nextElementSibling;
              if(nextEl && nextEl.classList.contains('submenu')) {
                // prevent opening link if link needs to open dropdown
                e.preventDefault();

                if(nextEl.style.display == 'contents'){
                  nextEl.style.display = 'none';
                } else {
                  nextEl.style.display = 'contents';
                }
              }
          });
        })

      });

    }
  //--------------fin 1

  //-----2
    // Quita el comportamiento de bootstrap normal (Desktop)
    function removeBsToggle(){
      var submenus = $(".submenu.s1");

      for(var i=0;i<submenus.length;i++){
        $(submenus[i]).parent().children("a").removeAttr("data-bs-toggle");
      }
    }
  //------fin 2

  //-----3
    // Restaura el comportamiento de bootstrap normal (Para movil)
    function restoreBsToggle(){
      var submenus = $(".submenu.s1");

      for(var i=0;i<submenus.length;i++){
        $(submenus[i]).parent().children("a").attr("data-bs-toggle", "dropdown");
      }
    }
  //----- fin 3

  //-- 4
  // Copia los enlaces de primer nivel dentro del container especial (Para desktop)
  function cloneChilds(){
    var submenus = $(".submenu.s1");

    for(var i=0;i<submenus.length;i++){
      $("#desktop-menu-container").append( $(submenus[i]).clone() );
    }
  }
  //--- fin 4

  //-- 5
  function submenuDesktop(){

    if (!submenu_functions) {
        // Hace que solo se ejecute la funcion 1 vez y asi no repetir el cargar manejadores
        submenu_functions = true;

        cloneChilds();

        // Manejador para abrir los contenedores del contenedor especial
        $(".main-navigation .nav-link").click(function(e){
          if (window.innerWidth > 900) {
            var target = $(this).attr("item-target");

            if(!$(".desktop-menu-container > .show").hasClass(target)){
              $(".desktop-menu-container > .show").removeClass("show");
            }

            if(!$(".desktop-menu-secundario > .show").hasClass(target)){
              $(".desktop-menu-secundario > .show").removeClass("show");
            }

            $(".desktop-menu-container > ." + target).toggleClass("show");
            $(".desktop-menu-secundario > ." + target).toggleClass("show");
          }
        });
    }

    if (window.innerWidth > 900) {
      removeBsToggle(); //Quita comportamiento bootstrap del menu ppal (hijos)
    }else{
      $(".main-navigation").addClass("menu-mobile");
      $(".sections-navigation").addClass("menu-mobile");
    }



    //-- pinchar fuera cierra menú
    $(document).click(function(event) {
      var obj = $(".nav-link");
      if (!obj.is(event.target) && !obj.has(event.target).length) {
          $(".submenu.s1").removeClass("show");
      }
    });

  //-- fin submenu desktop
  }
  // --- fin 5


  // FLECHAS MENU
  function arrowsMenu(){
      $(".nav-link").click(function (event) {

        $(this).toggleClass("openthis");

        $(".nav-link").not(this).removeClass("openthis");

      });
  }

  /**
  * CLASE ACTIVA DEL MAIN MENÚ
  *
  */
  function classActive(){
    var url = window.location.href;
    //MINISTERIO
    if (url.indexOf('/ministerio/') !== -1) {
      $('.navbar-nav .nav-item .nav-link').each(function() {
        var enlace = $(this);
        var textoBuscado = 'Ministerio';
        if (enlace.text().indexOf(textoBuscado) !== -1) {
          enlace.addClass('active');
        }
      });
    }
    //CONSUMO
    if (url.indexOf('/consumo/') !== -1) {
      $('.navbar-nav .nav-item .nav-link').each(function() {
        var enlace = $(this);
        var textoBuscado = 'Consumo';
        if (enlace.text().indexOf(textoBuscado) !== -1) {
          enlace.addClass('active');
        }
      });
    }
    //SERVICIOS
    if (url.indexOf('/servicios-al-ciudadano/') !== -1) {
      $('.navbar-nav .nav-item .nav-link').each(function() {
        var enlace = $(this);
        var textoBuscado = 'Servicios';
        if (enlace.text().indexOf(textoBuscado) !== -1) {
          enlace.addClass('active');
        }
      });
    }
    //COMUNICACIÓN
    if (url.indexOf('/comunicacion/') !== -1) {
      $('.navbar-nav .nav-item .nav-link').each(function() {
        var enlace = $(this);
        var textoBuscado = 'Comunicación';
        if (enlace.text().indexOf(textoBuscado) !== -1) {
          enlace.addClass('active');
        }
      });
    }
  }
  //------ fin funcion clase activa


  /**
  * ASPA BOTON HAMBURGUESA
  *
  */
  function cerrarBurger() {
    $(".close").hide();
    $(".navbar-toggler").click(function (event) {

      $(this).toggleClass("cerrarmenu");

      if($(".navbar-toggler").hasClass("cerrarmenu")){
              $(".open").hide();
              $(".close").show();
              $(".block-language-dropdown-blocklanguage-interface").show();
      }else{
              $(".open").show();
              $(".close").hide();
              $(".block-language-dropdown-blocklanguage-interface").hide();
            }
    });
  }
  function cerrarBurgerSections() {
    $(".close-sections").hide();
    $(".navbar-toggler-sections").click(function (event) {

      $(this).toggleClass("cerrarmenu");

      if($(".navbar-toggler-sections").hasClass("cerrarmenu")){
              $(".open-sections").hide();
              $(".close-sections").show();
      }else{
              $(".open-sections").show();
              $(".close-sections").hide();
            }
    });
  }




  // Manejador para cambiar entre el comportamiento desktop y movil (Cuando cambia de un modo a otro se cierran los desplegables que tocan)
  $(window).resize(function(){
    if (window.innerWidth > 900){
      $("#navbarNavDropdown .show").removeClass("show");
      $("#navbarNavDropdownSecondary .show").removeClass("show");
      submenuDesktop();

    }else{
      $("#desktop-menu-container > .show").removeClass("show");
      $("#desktop-menu-secundario > .show").removeClass("show");
      restoreBsToggle(); //Pone el comportamiento bootstrap del menu ppal (hijos)
    }
  });


  /**
  * NOLINK
  *
  */
  function nolink() {

    /* $('.submenu .dropdown-toggle').on().click(function (e) {
      e.preventDefault();
      $(this).addClass("nolink");
      return false;
    }); */

    $(document).ready(function () {
      // Seleccionar todos los <ul> con las clases 's2' y 's3' dentro de '.navbar-nav'
      const allS2 = document.querySelectorAll("#navbarNavDropdown .s2");
      const allS3 = document.querySelectorAll("#navbarNavDropdown .s3");

      // Añadir la clase 'show' utilizando className
      allS2.forEach((ul) => {
        if (!ul.className.includes("show")) {
          ul.className += " show";
        }
      });

      allS3.forEach((ul) => {
        if (!ul.className.includes("show")) {
          ul.className += " show";
        }
      });
    });
  }

  /**
  * CLASE PARA DIFERENCIAR MENU DESKTOP / MOBILE
  *
  */
  function mainMenuResize() {
    //--- MENU ESCRITORIO/MOVIL
    $(".main-navigation").addClass("menu-desktop");
    if (window.innerWidth < 900){
      $(".main-navigation").removeClass("menu-desktop");
      //menuMobileChild();
    }
    $(window).resize(function(){

      if (window.innerWidth < 900){
        //menuMobileChild();
        $(".main-navigation").addClass("menu-mobile");
        $(".main-navigation").removeClass("menu-desktop");
        //$("header").find(".menuhijo").removeClass("menuactivo");
      }else{
        $(".main-navigation").removeClass("menu-mobile");
        $(".main-navigation").addClass("menu-desktop");
      }
    });
  }

  function sectionsMenuResize() {
    $(".sections-navigation").addClass("menu-desktop");
    if (window.innerWidth < 900){
      $(".sections-navigation").removeClass("menu-desktop");
    }
    $(window).resize(function(){

      if (window.innerWidth < 900){
        $(".sections-navigation").addClass("menu-mobile");
        $(".sections-navigation").removeClass("menu-desktop");
      }else{
        $(".sections-navigation").removeClass("menu-mobile");
        $(".sections-navigation").addClass("menu-desktop");
      }
    });
  }

  //-- FIN MENU ESCRIOTIO/MOVIL



  /**
  * AJUSTES PARA ACCESIBILIDAD
  *
  */
    function accesibilidad() {
      /* TO DO */
    }
  //-- FIN AJUSTES PARA ACCESIBILIDAD

  /**
   * AJUSTES CARROUSEL (HOME)
   */
  function ajustesCarrousel(){
    $(window).on("load", function() {
      // Ruta de la imagen de la flecha izquierda
      var flechaIzquierda = "/themes/custom/pinst_theme/images/prev.svg";
      // Ruta de la imagen de la flecha derecha
      var flechaDerecha = "/themes/custom/pinst_theme/images/next.svg";
      // Insertar imagen de flecha izquierda
      $(".slick__arrow button:nth-child(1)").prepend("<img class='imagenPrev' src='" + flechaIzquierda + "' alt='Flecha Izquierda'>");
      // Insertar imagen de flecha derecha
      $(".slick__arrow button:nth-child(2)").prepend("<img class='imagenNext' src='" + flechaDerecha + "' alt='Flecha Derecha'>");
    });
  }
  //-- FIN AJUSTES CARROUSEL (HOME)

  /**
   * AJUSTES BLOQUE TWITTER (HOME)
   */
  function ajustesBloqueTwitter(){
    // Agregar una clase
    $('#block-twitter').addClass('block-twitter');
    $('#block-botondetwitterparavistaresponsive').addClass('block-twitter-responsive');
  }
  //-- FIN AJUSTES BLOQUE TWITTER (HOME)


  /**
   * AJUSTES FILTROS AVANZADOS EN DESPLEGABLE: participación pública
   */
  function filtroAvanzado(){
    $(".bef-exposed-form#views-exposed-form-buscador-participacion-page-1 #edit-created-wrapper").insertAfter(".bef-exposed-form#views-exposed-form-buscador-participacion-page-1 .bef--secondary .form-item-field-estado-target-id");
    $(".view-buscador-participacion .view-header").insertAfter(".view-buscador-participacion .view-filters");

  }

  /**
   * AJUSTES SEARCH PAGE
   */
  function ajustesSearchPage(){
    $('.form-wrapper>.form-submit').wrap('<span class="submit-search"></span>');
  }
  //-- FIN AJUSTES SEARCH PAGE

  /**
   * AJUSTES BLOQUE AYUDA
   */
  function bloqueAyuda(){
    var $nuevoSection = $('<section class="ayuda-materias-hijo">');

    // Mueve todos los elementos hijos al nuevo section
    $nuevoSection.append($('.ayuda-materias').children());

    // Reemplaza el contenido del div padre con el nuevo section
    $('.ayuda-materias').empty().append($nuevoSection);

    $('.ayuda-materias').prepend('<div class="icono"><img class="interrogante" src="/themes/custom/pinst_theme/images/interrogation.png"></div>')

  }
  //-- FIN AJUSTES SEARCH PAGE

  // Banner "Versiones amigables para Infancia y Adolescencia" (Desde tamaño tablet "700px" hacia abajo)
  // function bloqueBannerVersionesAmigables(){
  //   $(window).resize(function(){
  //     const img = document.getElementById('banner-amigable');
  //     const width = window.innerWidth;

  //     if (width <= 700) {
  //       img.src = '../../../../sites/default/files/2024-07/banner-amigable-movil4.png';
  //     }else{
  //       img.src = '../../../../sites/default/files/2024-06/banner-amigable.png';
  //     }
  //   });
  // }

  // Redimension de imagenes en secciones
  function seccionesImagesResize() {
    // Define variables para las imágenes fuera de la función `forEach`
    var imgSec1 = null;
    var imgSec2 = null;
    var imgSec3 = null;

    // Selecciona todos los elementos con la clase 'field--name-field-bs-imagen'
    var divsImagesSec = document.querySelectorAll('.field--name-field-bs-imagen');

    // Itera sobre cada elemento
    divsImagesSec.forEach(function(elemento) {
        var img = elemento.querySelector('img');
        if (img) {
            var alt = img.getAttribute('alt');
            // Asigna la imagen a la variable correspondiente basado en el atributo alt
            if (alt === 'Manos Juntas') {
                imgSec1 = img;
            } else if (alt === 'Personas Caminando') {
                imgSec2 = img;
            } else if (alt === 'Mano Tocando Cesped') {
                imgSec3 = img;
            }
        }
    });

    function actualizarImagenes() {
        var width = window.innerWidth;
        if (imgSec1 && imgSec2 && imgSec3) {
            if (width <= 1150) {
                imgSec1.src = '/sites/default/files/2024-07/manos-juntas-alargado.jpg';
                imgSec2.src = '/sites/default/files/2024-07/personas-caminando-alargado.jpg';
                imgSec3.src = '/sites/default/files/2024-07/mano-tocando-cesped-alargado.jpg';
            } else {
                imgSec1.src = '/sites/default/files/2024-07/manos-juntas.jpg';
                imgSec2.src = '/sites/default/files/2024-07/personas-caminando.jpg';
                imgSec3.src = '/sites/default/files/2024-07/mano-tocando-cesped.jpg';
            }
        }
    }

    // Ejecuta la función al cargar la página
    window.addEventListener('load', actualizarImagenes);

    // Ejecuta la función al redimensionar la ventana
    window.addEventListener('resize', actualizarImagenes);
  }

  function orderImage() {
    // Los .block__content con la clase .container son siempre bloque_seccion_*
    var blockContents = document.querySelectorAll('.block__content.container');
    if (blockContents) {
      blockContents.forEach(function(blockContent) {
        var posImg = blockContent.getAttribute('data-field-value');
        // Selecciona los elementos específicos
        var imageField = blockContent.querySelector('.block__content .info_bloque_imagen');
        var infoSection = blockContent.querySelector('.block__content .info_seccion');

        // Asigna las clases según el valor de classImg
        if (imageField && infoSection) {
          imageField.classList.remove('order-1', 'order-2');
          infoSection.classList.remove('order-1', 'order-2');

          if (posImg == 'Izquierda') {
            imageField.classList.add('order-1');
            infoSection.classList.add('order-2');
            blockContent.classList.add('imagen-izquierda');
          } else {
            imageField.classList.add('order-2');
            infoSection.classList.add('order-1');
            blockContent.classList.add('imagen-derecha');
          }
        }
      });
    }
  }

  function isExternalLink() {
    // Selecciona todos los enlaces de la página.
    var links = $('a');
    links.each(function() {
      var link = $(this);

      // Verifica si el enlace es externo comparando los hostnames.
      if (this.hostname && this.hostname !== window.location.hostname) {
        // Atributo de comportamiento: Abrir en ventana nueva
        link.attr('target', '_blank');
        // Atributo de Seguridad
        link.attr('rel', 'noopener noreferrer');
      }
    });

    //Nueva función para que los enlaces a documentos terminados en .pdf, .excel, .docx, .jpg o .png se abran en una nueva pestaña
    $('a[href*="/sites/"]').each(function () {
      var href = $(this).attr('href');
      if (href.match(/\.(pdf|excel|docx|jpg|png|xls|zip)$/i)) {
        $(this).attr('target', '_blank');
      }
    });
  }

  function orderLinks() {
    // Ejecuta la función al cargar la página
    window.addEventListener('load', seccionesImagenesEnlaces);
  }

  function seccionesImagenesEnlaces() {
    // Selecciona todos los elementos con la clase 'field--name-field-bs-imagen'
    var containers = document.querySelectorAll('.info_seccion .field--name-field-bs-enlace');

    containers.forEach(container => {
      const items = container.getElementsByClassName('field__item');

      // Crea dos contenedores para las columnas
      const column1 = document.createElement('div');
      const column2 = document.createElement('div');
      column1.className = 'column1';
      column2.className = 'column2';

      // Divide los enlaces en dos columnas
      const mitadEnlaces = Math.ceil(items.length / 2);
      Array.from(items).forEach((item, index) => {
          if (index < mitadEnlaces) {
              column1.appendChild(item);
          } else {
              column2.appendChild(item);
          }
      });

      // Vacía el contenedor actual y agrega las dos columnas
      container.innerHTML = '';
      container.appendChild(column1);
      container.appendChild(column2);

      reiniciarAlturas();
    });
  }

  // Función para reiniciar y ajustar las alturas de las columnas
  function ajustarAlturas() {
    const containers = document.querySelectorAll('.info_seccion .field--name-field-bs-enlace');

    containers.forEach(container => {
      const column1 = container.querySelector('.column1');
      const column2 = container.querySelector('.column2');

      if (!column1 || !column2) return;

      const column1Items = Array.from(column1.children);
      const column2Items = Array.from(column2.children);

      const maxLength = Math.max(column1Items.length, column2Items.length);

      for (let i = 0; i < maxLength; i++) {
        const item1 = column1Items[i];
        const item2 = column2Items[i];

        // Reinicia las alturas para recalcular correctamente
        if (item1) item1.style.height = 'auto';
        if (item2) item2.style.height = 'auto';

        const height1 = item1 ? item1.offsetHeight : 0;
        const height2 = item2 ? item2.offsetHeight : 0;
        const maxHeight = Math.max(height1, height2);

        if (item1) item1.style.height = `${maxHeight+20}px`;
        if (item2) item2.style.height = `${maxHeight+20}px`;
      }
    });
  }

  //Evento que se ejecuta cada vez que se pasan los límites de cambio de diseño de 1150px y de 700px
  function reiniciarAlturas() {
    // Estado inicial para seguimiento de los umbrales
    let wasBelow1150 = false;
    let wasBelow900 = false;
    let wasBelow700 = false;

    // Define los umbrales de ancho en píxeles
    const threshold1150 = 1150;
    const threshold900 = 900;
    const threshold700 = 700;

    // Función que se ejecuta al pasar el umbral de 1150px
    function onResizeAbove1150() {
      ajustarAlturas(); // Ajustar alturas cuando se pasa el umbral
    }

    // Función que se ejecuta al bajar de 1150px
    function onResizeBelow1150() {
      ajustarAlturas(); // Ajustar alturas cuando se baja del umbral
    }

    // Función que se ejecuta al pasar el umbral de 900px
    function onResizeAbove900() {
      ajustarAlturas(); // Ajustar alturas cuando se pasa el umbral
    }

    // Función que se ejecuta al bajar de 900px
    function onResizeBelow900() {
        ajustarAlturas(); // Ajustar alturas cuando se baja del umbral
    }


    // Función que se ejecuta al pasar el umbral de 700px
    function onResizeAbove700() {
      ajustarAlturas(); // Ajustar alturas cuando se pasa el umbral
    }

    /* // Función que se ejecuta al bajar de 700px
    function onResizeBelow700() {
      ajustarAlturas(); // Ajustar alturas cuando se baja del umbral
    } */

    // Listener para el evento resize
    window.addEventListener('resize', function () {
      const currentWidth = window.innerWidth;

      // Verifica umbral de 1150px
      if (currentWidth > threshold1150 && !wasBelow1150) {
        onResizeAbove1150();
        wasBelow1150 = false;
      } else if (currentWidth <= threshold1150 && wasBelow1150) {
        onResizeBelow1150();
        wasBelow1150 = true;
      }

      // Verifica umbral de 900px
      if (currentWidth > threshold900 && !wasBelow900) {
        onResizeAbove900();
        wasBelow900 = false;
      } else if (currentWidth <= threshold900 && wasBelow900) {
        onResizeBelow900();
        wasBelow900 = true;
      }

      // Verifica umbral de 700px
      if (currentWidth > threshold700 && !wasBelow700) {
        onResizeAbove700();
        wasBelow700 = false;
      } /* else if (currentWidth <= threshold700 && wasBelow700) {
        onResizeBelow700();
        wasBelow700 = true;
      } */
    });

    // Listener para el evento resize
    window.addEventListener('load', function () {
      const currentWidth = window.innerWidth;

      // Verifica umbral de 1150px
      if (currentWidth > threshold1150 && !wasBelow1150) {
        onResizeAbove1150();
        wasBelow1150 = false;
      } else if (currentWidth <= threshold1150 && wasBelow1150) {
        onResizeBelow1150();
        wasBelow1150 = true;
      }

      // Verifica umbral de 900px
      if (currentWidth > threshold900 && !wasBelow900) {
        onResizeAbove900();
        wasBelow900 = false;
      } else if (currentWidth <= threshold900 && wasBelow900) {
        onResizeBelow900();
        wasBelow900 = true;
      }

      // Verifica umbral de 700px
      if (currentWidth > threshold700 && !wasBelow700) {
        onResizeAbove700();
        wasBelow700 = false;
      } /* else if (currentWidth <= threshold700 && wasBelow700) {
        onResizeBelow700();
        wasBelow700 = true;
      } */
    });

    // Inicializa las variables de estado según el tamaño actual de la ventana
    document.addEventListener('DOMContentLoaded', function () {
      const currentWidth = window.innerWidth;
      wasBelow1150 = currentWidth <= threshold1150;
      wasBelow900 = currentWidth <= threshold900;
      wasBelow700 = currentWidth <= threshold700;
    });
  }

  //::::::::::::::::::::::::::::::::::::::::::::::::::
  //          ENTRADA DE EJECUCION PRINCIPAL
  //::::::::::::::::::::::::::::::::::::::::::::::::::
  $(document).ready(function(){
    menuMultilevel();
    submenuDesktop();
    arrowsMenu();
    cerrarBurger();
    cerrarBurgerSections();
    mainMenuResize();
    sectionsMenuResize();
    nolink();
    accesibilidad();
    ajustesCarrousel();
    ajustesBloqueTwitter();
    filtroAvanzado();
    ajustesSearchPage();
    classActive();

    orderImage();
    isExternalLink();
    orderLinks();
    reiniciarAlturas();

    //bloqueBannerVersionesAmigables();
    seccionesImagesResize();
    $(window).resize(function(){
      //bloqueBannerVersionesAmigables();
      seccionesImagesResize();
      reiniciarAlturas();
      if ($(window).width() <= 900 ) {
        nolink();
      }
    });
    // bloqueAyuda();

  });
  //::::::::::::::::::::::::::::::::::::::::::::::::::
  //::::::::::::::::::::::::::::::::::::::::::::::::::
})(jQuery, Drupal, drupalSettings);
